import { useCmsContent } from 'src/hooks';
import React, { useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { START_HERE_CHALLENGE_ID } from 'src/models/Challenge';

type UseBottomNavigationPropsType = {
  practicePlanLink?: string | null;
}

type UseBottomNavigationReturnType = {
  bottomNavigationChangeRoute: (index: number) => void,
  tabIndex: number
}

export type PyMenuItem = {
  path: string;
  label: string;
  children?: PyMenuItem[];
  isFeatured?: boolean;
}

export const useMenuItemsOld = () => {
  const practicePlanLink = useCmsContent().links.practicePlan;
  return useMemo(() => [
    {
      path: '/sessions',
      label: 'Sesje jogi',
    },
    {
      path: '/meditations',
      label: 'Medytacje',
    },
    {
      path: '/challenges',
      label: 'Wyzwania',
    },
    {
      path: '/pilates',
      label: 'Pilates',
    },
    {
      path: '/teachers',
      label: 'Nauczyciele',
    },
    {
      path: 'https://portalyogi.pl/twojebenefity/',
      label: 'Twoje benefity',
    },
    {
      path: 'https://www.facebook.com/groups/grupa.portalyogi/',
      label: 'Grupa',
    },
    practicePlanLink ? {
      path: practicePlanLink,
      label: 'Plan praktyki',
    } : undefined,
  ].filter((item): item is PyMenuItem => !!item), [practicePlanLink]);
};

export const useMenuItems = () => {
  return useMemo((): PyMenuItem[] => [
    {
      path: `/challenges/${START_HERE_CHALLENGE_ID}`,
      label: 'Tu zacznij!',
      isFeatured: true,
    },
    {
      path: '',
      label: 'Sesje',
      children: [
        {
          path: '/sessions',
          label: 'Joga',
        },
        {
          path: '/meditations',
          label: 'Medytacje',
        },
        {
          path: '/pranayama',
          label: 'Pranayama/Oddech',
        },
        {
          path: '/pilates',
          label: 'Pilates',
        },
        {
          path: '/fit-sessions',
          label: 'Zajęcia fit',
        },
        {
          path: '/discoveries',
          label: 'Odkrycia PortalYogi',
        },
      ],
    },
    {
      path: '',
      label: 'Programy',
      children: [
        {
          path: '/challenges',
          label: 'Wyzwania',
        },
        {
          path: '/practice-plans',
          label: 'Plany Praktyki',
        },
      ],
    },
    {
      path: '/teachers',
      label: 'Nauczyciele',
    },
    {
      path: 'https://portalyogi.pl/twojebenefity/',
      label: 'Twoje benefity',
    },
    {
      path: 'https://www.facebook.com/groups/grupa.portalyogi/',
      label: 'Grupa',
    },
  ], []);
};

const userMenuItems = [
  {
    path: '/me/practice',
    label: 'Moja praktyka',
  },
  {
    path: '/me/playlists',
    label: 'Playlisty',
  },
  {
    path: '/me/subscription',
    label: 'Zarządzaj subskrypcją',
  },
  {
    path: '/me/payments',
    label: 'Historia płatności',
  },
  {
    path: '/logout',
    label: 'Wyloguj się',
  },
];

export const useUserMenuItems = () => userMenuItems;

export const useBottomNavigation = (_props?: UseBottomNavigationPropsType): UseBottomNavigationReturnType => {
  const history = useHistory();
  const [tabIndex, setTabIndex] = React.useState(0);

  const bottomNavigationChangeRoute = (index: number) => {
    setTabIndex(index);
    switch (index) {
      case 0:
        history.push('/sessions');
        break;
      case 1:
        history.push('/meditations');
        break;
      case 2:
        history.push('/practice-plans');
        break;
      case 3:
        history.push('/me/summary');
        break;
      default:
        history.push('/home')
    }
  }

  useEffect(() => {
    if (history.location.pathname.includes('/sessions')) {
      setTabIndex(0);
      return;
    }

    if (history.location.pathname.includes('/meditations')) {
      setTabIndex(1);
      return;
    }

    if (
      history.location.pathname.includes('/me/practice') ||
      history.location.pathname.includes('/me/playlists') ||
      history.location.pathname.includes('/me/summary')
    ) {
      setTabIndex(3);
      return;
    }

    if (history.location.pathname.includes('/practice-plans')) {
      setTabIndex(2);
      return;
    }
  }, [history.location.pathname]);

  return {
    bottomNavigationChangeRoute,
    tabIndex
  }
}
